import { render, staticRenderFns } from "./HealthRecords.vue?vue&type=template&id=2199e80a&scoped=true&"
import script from "./HealthRecords.vue?vue&type=script&lang=js&"
export * from "./HealthRecords.vue?vue&type=script&lang=js&"
import style0 from "./HealthRecords.vue?vue&type=style&index=0&id=2199e80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199e80a",
  null
  
)

export default component.exports